export default __webpack_public_path__ + "static/media/wonderpals_8105.f5cb29db.png";